import Model, { attr } from '@ember-data/model';

export default class SerpResultLocal extends Model {
  @attr('string') cid;
  @attr('string') url;
  @attr('string') title;
}
